module.exports = __webpack_public_path__ + "img/cpam.4a9e2dfe.png";